import {createApp} from 'vue'
import Store from 'store'
import QuickOrder from './QuickOrder'

const el = '.nlx-component--quick-order'
const DOM = document.querySelector(el)

if(DOM){

    const quickOrderProps = {
        title : parseInt(DOM.dataset.title)
    }

    const component = createApp(QuickOrder, {...quickOrderProps}).use(Store)

    component.mount(el)
}


